"use strict";
exports.__esModule = true;
exports.ColorLegend = exports.ColorBoxes = exports.ColorLabels = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var helpers_1 = require("./helpers");
var PositionTypes_1 = require("./PositionTypes");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
function ColorLabels(colorLabelProps) {
    var labels = colorLabelProps.labels;
    return (react_1["default"].createElement("div", { className: "labels" }, labels.map(function (item) {
        var key = item.key, label = item.label, style = item.style;
        return (react_1["default"].createElement("span", { key: key, style: style }, label));
    })));
}
exports.ColorLabels = ColorLabels;
function ColorBoxes(colorBoxProps) {
    var boxes = colorBoxProps.boxes;
    return (react_1["default"].createElement("div", { className: "boxes" }, boxes.map(function (box) {
        var classes = classnames_1["default"]("box", box["class"]);
        var key = box.key, style = box.style;
        return react_1["default"].createElement("span", { className: classes, key: key, style: style });
    })));
}
exports.ColorBoxes = ColorBoxes;
function LegendBoxes(_a) {
    var renderLabelsFirst = _a.renderLabelsFirst, boxes = _a.boxes, labels = _a.labels;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        renderLabelsFirst ? react_1["default"].createElement(ColorLabels, { labels: labels }) : null,
        react_1["default"].createElement(ColorBoxes, { boxes: boxes }),
        !renderLabelsFirst && react_1["default"].createElement(ColorLabels, { labels: labels })));
}
function LegendWithTitle(props) {
    var title = props.title, position = props.position, children = props.children;
    var isHorizontal = position === PositionTypes_1.TOP || position === PositionTypes_1.BOTTOM;
    var classes = classnames_1["default"]("heatmap-legend-with-title", { horizontal: isHorizontal });
    return (react_1["default"].createElement("div", { className: classes },
        react_1["default"].createElement("div", { className: "heatmap-legend-title" }, title + ":"),
        react_1["default"].createElement("div", { className: "heatmap-legend-boxes" }, children)));
}
/**
 * @internal
 */
exports.ColorLegend = sdk_ui_theme_provider_1.withTheme(function (colorLegendProps) {
    var title = colorLegendProps.title, data = colorLegendProps.data, format = colorLegendProps.format, numericSymbols = colorLegendProps.numericSymbols, _a = colorLegendProps.size, size = _a === void 0 ? "large" : _a, position = colorLegendProps.position, theme = colorLegendProps.theme;
    if (!data.length) {
        return null;
    }
    var config = helpers_1.getColorLegendConfiguration(data, format, numericSymbols, size, position, theme);
    var classes = classnames_1["default"].apply(void 0, config.classes);
    var renderLabelsFirst = config.position === PositionTypes_1.TOP;
    var boxes = config.boxes, labels = config.labels;
    return (react_1["default"].createElement("div", { className: classes }, title ? (react_1["default"].createElement(LegendWithTitle, { title: title, position: position },
        react_1["default"].createElement(LegendBoxes, { renderLabelsFirst: renderLabelsFirst, boxes: boxes, labels: labels }))) : (react_1["default"].createElement(LegendBoxes, { renderLabelsFirst: renderLabelsFirst, boxes: boxes, labels: labels }))));
});
//# sourceMappingURL=ColorLegend.js.map